import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { DeadLine } from '../../../models/quotation-model/catalogs/dead-line.model';
import {
  QuoterDeadlinePaged,
  QuoterDeadline,
} from '../../../models/quotation-model/catalogs/quoterConfig/quoter-deadline.model';
import { CommonFilterRequest, CommonResult } from '../../../models/quotation-model/customer.model';

@Injectable({
  providedIn: 'root',
})
export class DeadLineService {
  URL_API = environment.apiURL;
  constructor(private http: HttpClient) {}

  getDeadLines(planId: number, insuranceId: number, programId: number): Observable<DeadLine[]> {
    let condition: string = 'ABIERTO';
    return this.http.get<DeadLine[]>(
      this.URL_API +
        '/Deadline?condition=' +
        condition +
        '&planId=' +
        planId +
        '&insuranceId=' +
        insuranceId +
        '&programId=' +
        programId,
    );
  }

  getDeadLinesToYear(yearId: number): Observable<DeadLine[]> {
    return this.http.get<DeadLine[]>(
      this.URL_API + '/Deadline/GetDeadlinesToYear?yearId=' + yearId,
    );
  }

  getDeadLinesToPlan(planId: number): Observable<DeadLine[]> {
    return this.http.get<DeadLine[]>(
      this.URL_API + '/Deadline/GetDeadlinesToPlan?planId=' + planId,
    );
  }

  getDeadLinesToInsurance(insuranceId: number): Observable<DeadLine[]> {
    return this.http.get<DeadLine[]>(
      this.URL_API + '/Deadline/GetDeadlinesToInsurance?insuranceId=' + insuranceId,
    );
  }

  getPagedDeadlines(filters: CommonFilterRequest): Observable<QuoterDeadlinePaged> {
    const params = new HttpParams()
      .set('page', filters.page.toString())
      .set('pageSize', filters.pageSize.toString())
      .set('sortActive', filters.sortActive)
      .set('sortDirection', filters.sortDirection)
      .set('filter', filters.filter ? filters.filter : '');
    return this.http.get<QuoterDeadlinePaged>(this.URL_API + '/Deadline/GetPagedDeadlines', {
      params,
    });
  }

  upsertQuoterDeadline(upsertDeadline: QuoterDeadline) {
    return this.http.post<CommonResult>(this.URL_API + '/Deadline/UpsertDeadline', upsertDeadline);
  }
}
